<script>
import RecruitContent from "@/components/career/RecruitContent.vue";

export default {
  name: "Staff02",
  components: {RecruitContent},
  data(){
    return {
      heading01: '',
      description01: '',
      description02: '',
      description03: '',
      heading02: ''
    }
  },
  methods: {
    resize(){
      const text = 'キャリアアップのため、\nネットワークシステムの\n上流工程に挑戦。'
      const textMB =`キャリアアップのため、\nネットワークシステムの\n上流工程に挑戦。`
      const text02 = '前例のない環境で、\n新システム導入の指揮をとる。'
      const text02MB = '前例のない環境で、\n新システム導入の指揮をとる。'
      const description01 = 'システム刷新'
      const description02 = 'プロジェクトへの挑戦。'
      const description03 = '正解のない中で最適解を導き出す。'
      if(window.innerWidth < 901){
        this.heading01 = textMB
        this.heading02 = text02
        this.description01 = description01
        this.description02 = description02
        this.description03 = description03
      }else{
        this.heading01 = text
        this.heading02 = text02MB
        this.description01 = description01+description02
        this.description02 = description03
        this.description03 = ''
      }
    }
  },
  mounted() {
    this.resize()
    window.addEventListener('resize', this.resize)
  }
}
</script>

<template>
<div>
  <recruit-content
      name="光吉 雅智"
      office="情報システム部"
      join-year="2020"
      sort="02"
      :tags="'#ネットワークエンジニア  #システム導入\n#正解がない仕事'"
      title="情報システム"
      :description01="description01"
      :description02="description02"
      :description03="description03"
      :banner="require('@/assets/img/career/02/hero.jpg')"
      :banner-sp="require('@/assets/img/career/02/hero-sp.jpg')"
      :answer-heading01="heading01"
      :answer-image01="require('@/assets/img/career/02/image-01.jpg')"
      answer-paragraph01="前職では基幹ネットワークや各種システムの運用保守を担当していました。3年ほど勤務する中で、システムの設計や要件定義に携わりたい気持ちが日に日に高まっていき、上流工程メインで担当できる環境を求めて転職活動を始めました。ネットワークエンジニアは、企画から運用保守まで一貫して行う場合が多い中、クレハではシステム導入は本社、運用はいわき事業所、と場所によって役割が分かれています。ここでなら、自分が専門性を高めたかった上流工程の経験を積んでいけると思いました。最終的にクレハに決めたのは、SDN(Software Defined Network)という新しいネットワーク技術を使ったシステム導入プロジェクトに携われるからです。デジタル技術は日進月歩で進化するもの。最新技術を取り入れながら、ネットワークエンジニアとしてのキャリアを積みたい。そんな思いもあり、このシステム導入プロジェクトは、私にとってまたとない機会だと思いました。また、入社後に担当するプロジェクトの内容が明確化されていたため、業務イメージがしやすく、自分のやりたい仕事ができると確信することができました。"
      :answer-heading02="heading02"
      :answer-image02="require('@/assets/img/career/02/image-02.jpg')"
      answer-paragraph02="クレハに入社してすぐに、現行システムの分析と運用の見直しを行いました。その際、新たにネットワーク監視システムを導入したのですが、比較的スムーズに進められたのは前職での経験があったからこそだと思います。現在は、現行ネットワークの運用保守をしながら、導入するネットワークの検討や導入プロジェクトのマネジメントを行っています。ネットワークの導入プロジェクトで最も大変なのは「正解がない」ということです。社内に前例がないため、一からこの会社に適したネットワークシステムを探す必要があります。しかし、全ての要件に完璧なシステムはありません。だからこそ、検討段階でサービスの選定基準を示した上で、どの評価項目を重要とするのかを明確化する必要があるのです。この要件定義が、プロジェクトの方向性を左右するといっても過言ではありません。正解がない中で、最適解を導き出す。それこそが私たちに課せられたミッションなのです。現在、クレハではデータ運用をクラウド化するためにネットワークの刷新プロジェクトが進行しています。これは私たちインフラチームが主体となって会社に提案したプロジェクトで、今は検討段階ですが、このプロジェクトを軌道に乗せることが直近の目標です。"
      :answer-image03="require('@/assets/img/career/02/image-04.jpg')"
      :answer-heading03="'エンジニアとしての成長と\n会社の発展を同時に叶える人財へ。'"
      answer-paragraph03="現在進行しているネットワークシステムの導入が完了したら、そのネットワークをさらに活用して、業務効率化やセキュリティ強化を図っていきたいと考えています。今は顕在化していなくとも、ネットワークを運用する中で見えてくる課題も多くあるはずです。今よりももっと質の高いネットワークインフラを整備するには何をすればよいか、常に問い続けながら答えを探していきたいと思います。また、学生時代から生粋のエンジニア気質であるため、新しいシステムを導入して実際に運用してみること自体に楽しみを感じるんです。そのため、裁量権を持っていろいろなネットワークシステムを検討できるクレハは、私にとって最高の環境です。そのおかげでモチベーション高く仕事に取り組めています。また、クレハのシステムは統括しやすい規模感であるため、取り組みの成果が目に見えてわかりやすく、自分のやりたいことが会社の発展に直結している感覚があります。ネットワークエンジニアとしての成長と会社の発展、この両輪を回すような仕事をしていきたいと思います。"
      :banner-full="require('@/assets/img/career/02/image-03.jpg')"
      :banner-full-sp="require('@/assets/img/career/02/image-03-sp.jpg')"
      class-custom="staff02"
  />
</div>
</template>

<style lang="scss">
.staff02{
& > .hero-banner{
  padding-bottom: 90px;
  & > .title{
    & > div{
      &:first-child{
        @media print, screen and (max-width: 900px) {
          top: -2.7%;
        }

        @media print, screen and (max-width: 456px) {
          top: 1%;
        }

        & > p{
          & > span{
            &:last-child{
              @media print, screen and (max-width: 456px) {
                white-space: pre !important;
                height: 64px;
              }
            }
          }
        }
      }
      &:last-child{
        @media print, screen and (max-width: 900px) {
          bottom: 2%;
        }
      }

    }
  }
}
}
</style>
